import React, { useEffect, useState } from "react";
import { ToggleButtonGroup, ToggleButton } from "@mui/material";
import ViewListIcon from "@mui/icons-material/ViewList";
import ViewModuleIcon from "@mui/icons-material/ViewModule";
import { useSelector } from "react-redux";
export function ViewToggle({
  view,
  // defaultView,
  onChange,
  ariaLabel = "Toggle view mode",
}) {
  const displaySettings = useSelector(
    (state) => state.user.displayTabSettings["my-drawings"]
  );
  useEffect(() => {
    onChange(displaySettings?.defaultView);
  }, [displaySettings?.defaultView]);
  const handleChange = (event, newView) => {
    if (newView !== null) {
      onChange(newView);
    }
  };

  return (
    <ToggleButtonGroup
      value={view}
      exclusive
      onChange={handleChange}
      aria-label={ariaLabel}
      size="small"
      sx={{
        bgcolor: "#F2F2F2",
        "& .MuiToggleButton-root": {
          border: "1px solid #E5E7EB",
          color: "#4A5565",
          padding: "6px 12px",
          borderRadius: "10px !important",
          "&.Mui-selected": {
            bgcolor: "#2932E5",
            color: "#FFFFFF",
            "&:hover": {
              bgcolor: "#1E25B8",
            },
            borderRadius: "10px !important",
          },
          "&:hover": {
            bgcolor: "#E5E7EB",
          },
        },
      }}
    >
      <ToggleButton value="list" aria-label="list view" title="List view">
        <ViewListIcon fontSize="small" />
      </ToggleButton>
      <ToggleButton value="grid" aria-label="grid view" title="Grid view">
        <ViewModuleIcon fontSize="small" />
      </ToggleButton>
    </ToggleButtonGroup>
  );
}
